import React, { useEffect, useState, createContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";

import Swal from "sweetalert2";
import CreateAppointmentRequestReq from "../../../Classes/Models/Requests/Appointments/CreatePatientAppointmentRequestReq";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useContext } from "react";
import AsyncSelect from "react-select/async";

import UsersApi from "../../../Classes/API/UsersApi";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";

const index = () => {
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new CreateAppointmentRequestReq());
  const { state } = useLocation();
  const [IsLoaded, setIsLoaded] = useState(false);
  const [AppRequests, setAppRequests] = useState({});
  const [TableDataRows, setTableDataRows] = useState([]);
  const [ResponseData, setResponseData] = useState({});

  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);

  const [AppointmentMade, setAppointmentMade] = useState();
  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});
  const [AccSessionId, setAccSessionId] = useState();

  const TableColumns = [
    { Header: "Id", accessor: "Id", align: "left" },
    { Header: "Patient", accessor: "Patient", align: "left" },
    { Header: "AccSessionId", accessor: "AccSessionId", align: "left" },
    { Header: "Session Name", accessor: "SessionName", align: "left" },
    { Header: "Requested Times", accessor: "RequestedTimes", align: "left" },
    { Header: "Appointment Made", accessor: "AppointmentMade", align: "left" },
    { Header: "Action", accessor: "Action", align: "left" },
  ];

  const AppTimesCell = (appReq) => {
    return (
      <MDBox>
        {appReq.firstPrioTime && (
          <MDBox display="flex">
            <MDTypography variant="body2" color="success">
              First Priority &nbsp;
            </MDTypography>
            <MDTypography variant="body2" color="primary">
              {appReq.firstPrioTime.replace("T", " -- ")}
            </MDTypography>
          </MDBox>
        )}
        {appReq.secondPrioTime && (
          <MDBox display="flex">
            <MDTypography variant="body2" color="seconday">
              Second Priority &nbsp;
            </MDTypography>

            <MDTypography variant="body2" color="primary">
              {appReq.secondPrioTime.replace("T", " -- ")}
            </MDTypography>
          </MDBox>
        )}
        {appReq.thirdPrioTime && (
          <MDBox display="flex">
            <MDTypography variant="body2" color="warning">
              Third Priority &nbsp;
            </MDTypography>
            <MDTypography variant="body2" color="primary">
              {appReq.thirdPrioTime.replace("T", " -- ")}
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    );
  };

  const MakeTableRow = (appReq) => {
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {appReq.id}
        </MDTypography>
      ),

      Patient: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {appReq.getPatient.getUser.name}
        </MDTypography>
      ),

      AccSessionId: (
        <MDTypography
          onClick={() =>
            navigate("/AccountingSessions/Details", {
              state: {
                SearchSession: appReq.getAccountingSession,
              },
            })
          }
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          {appReq.getAccountingSession.id}
        </MDTypography>
      ),

      SessionName: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {appReq.getAccountingSession.getSession.name}
        </MDTypography>
      ),

      RequestedTimes: <>{AppTimesCell(appReq)}</>,

      AppointmentMade: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {appReq.getAppointment ? "Yes" : "No"}
        </MDTypography>
      ),

      Action: (
        <MDButton
          onClick={() => navigate("/Appointments/CreateAppointment")}
          variant="contained"
          color="primary"
        >
          Create Appointment
        </MDButton>
      ),
    };
  };

  const GetPatients = async () => {
    let searchReq = new searchUsersReq();
    let UserTypes1 = new UserTypes();

    searchReq.name = PatientsSearch;
    searchReq.userType = UserTypes1.Patient;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.getPatient, label: item.name });
      });
      return optionsArr;
    }
  };
  const GetPatientAppointmentRequests = async () => {
    SearchReq.pagingParams.pageSize = 5;
    let res = await AppointmentsApi.SearchPatientAppointments(SearchReq);

    if (res.status == "Success") {
      setAppRequests(res.data);
      setTotalPages(res.totalPages);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };
  useEffect(async () => {
    await GetPatientAppointmentRequests();
  }, [SearchReq]);

  useEffect(() => {
    if (Object.keys(AppRequests).length < 1 || !IsLoaded) {
      GetPatientAppointmentRequests("TODO");
    }

    if (IsLoaded) {
      console.log(AppRequests);
      setTableDataRows(AppRequests.list.map((appReq) => MakeTableRow(appReq)));
    }
  }, [IsLoaded]);

  useEffect(() => {
    if (Object.keys(AppRequests).length > 0) {
      setIsLoaded(true);
    }
  }, [AppRequests]);

  useEffect(() => {
    SearchReq.pagingParams.page = Page;
    setSearchReq(SearchReq);
    GetPatientAppointmentRequests();
  }, [Page]);

  const onSearch = async () => {
    let searchReq = new CreateAppointmentRequestReq();
    searchReq.patientId = Patient.id;
    searchReq.AccountingSessionId = AccSessionId;
    searchReq.AppointmentMade = AppointmentMade;
    setSearchReq(searchReq);
    await GetPatientAppointmentRequests();
  };
  if (!IsLoaded) {
    return <div>Loading...</div>;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card mb={3} className="mx-4 mt-3 p-3" sx={{ marginBottom: "2em" }}>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            Search
          </MDTypography>
        </MDBox>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setAccSessionId(e.target.value)}
                label={"Accounting Session Id"}
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <label>
                <input
                  type="checkbox"
                  className="mr-2"
                  defaultChecked={AppointmentMade}
                  onChange={() => setAppointmentMade(!AppointmentMade)}
                />
                Appointment Made
              </label>
            </div>
            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="regular" color="text">
                Select Patient:
                <AsyncSelect
                  isClearable={true}
                  loadOptions={GetPatients}
                  onInputChange={setPatientsSearch}
                  onChange={(e) => setPatient(e ? e.value : "")}
                  // value={TypeId}
                />
              </MDTypography>
            </div>
          </div>
          <div className="col-md-12 text-right">
            <button
              type="button"
              className="btn btn-primary mt-2 float-right"
              onClick={() => onSearch()}
            >
              Search
            </button>
          </div>
        </div>
      </Card>
      <Card>
        <CardHeader className="mb-2" title="Appointments Requests"></CardHeader>

        <MDBox pt={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>

        <div className="text-right mx-3 my-4">
          <Pagination
            count={TotalPages}
            onChange={(e, num) => setPage(num)}
            color="primary"
            className="float-right"
          />
        </div>
      </Card>
    </DashboardLayout>
  );
};

export default index;
